var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-hover"},[_c('p',[_vm._v("Overdue by "+_vm._s(_vm.formattedTime))]),_c('hr'),_c('p',[_vm._v("Last Response by "+_vm._s(_vm.lastResponseText))]),_c('p',[_vm._v(_vm._s(_vm.lastMessageUpdateTimeString))])])
}
var staticRenderFns = []

export { render, staticRenderFns }